import { render, staticRenderFns } from "./UnknowComponent.vue?vue&type=template&id=5a3cef4c&"
import script from "./UnknowComponent.vue?vue&type=script&lang=js&"
export * from "./UnknowComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports